import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const AssetTypesViewTopBar = memo(() => {
	return <BaseTopBar />
})
AssetTypesViewTopBar.displayName = "AssetTypesViewTopBar"
